<div class="dialog-warning-container">
  <div class="header">
    <div class="warning-wrapper">
      <div class="warning-wrapper__icon">
        <span class="warning-wrapper__icon__sign">!</span>
      </div>
      <div class="warning-wrapper__txt color-txt-black">¡Atención!</div>
    </div>
  </div>

  <div mat-dialog-content class="content-detail">
    <section class="content-detail-section existing-contact mb-">
      <h4 class="color-txt-black">{{ lblExistContact }}</h4>

      <div class="existing-contact-content">
        <div class="existing-contact-content__attibutes">
          <span>Nombre:</span>
          <span>Alias:</span>
          <span>Empresa:</span>
        </div>
        <div class="existing-contact-content__info">
          <span>{{ contactFound['name'] ? contactFound['name'] : '-' }}</span>
          <span>{{ contactFound['alias'] ? contactFound['alias'] : '-' }}</span>
          <span>{{
            contactFound['enterpriseName'] ? contactFound['enterpriseName'] : '-'
          }}</span>
        </div>
      </div>
    </section>

    <ng-container *ngIf="!isContactInCurrentRoom">
      <section class="content-detail-section existing-room">
        <h4 class="color-txt-black">Este contacto ya existe en las salas:</h4>
        <ul>
          <ng-container *ngFor="let room of contactRooms">
            <li>{{ room['roomName'] }}</li>
          </ng-container>
        </ul>
      </section>

      <div class="divider"></div>

      <section class="content-detail-section caption">
        <div>Si selecciona:</div>
        <div class="caption-info">
          <span>Actualizar y crear Chat</span>, los datos del contacto se cambiarán
          en todas las salas en donde éste se encuentra.
        </div>
        <div class="caption-info">
          <span>No Actualizar y crear Chat</span>, se creará el chat en esta sala,
          con los datos existentes del contacto, no los que ud. ingresó.
        </div>
        <div class="caption-info">
          <span>Cancelar</span>, no se realizará ningún cambio.
        </div>
      </section>
    </ng-container>

    <ng-container *ngIf="isContactInCurrentRoom">
      <div class="txt-exist-contact">No se realiza ningún cambio.</div>
    </ng-container>
  </div>

  <div
    mat-dialog-actions
    class="mt-20 mat-dialog-actions mat-dialog-actions-custom"
    [ngClass]="{ 'contact-current-room': isContactInCurrentRoom }">
    <ng-container *ngIf="!isContactInCurrentRoom">
      <div class="mat-dialog-actions-custom__left">
        <button
          mat-raised-button
          type="button"
          class="mr-8"
          aria-label="cancel"
          style="background-color: #7d818c !important; color: white"
          (click)="matDialogRef.close()">
          Cancelar <br />
        </button>
      </div>
      <div class="mat-dialog-actions-custom__right">
        <button
          mat-raised-button
          type="button"
          class="submit-button"
          color="accent"
          class="save-button"
          aria-label="SAVE"
          (click)="onSubmit(false)">
          <span>No Actualizar y <br />crear Chat</span>
        </button>
        <button
          mat-raised-button
          type="button"
          class="submit-button"
          color="accent"
          class="save-button"
          aria-label="SAVE"
          (click)="onSubmit(true)">
          <span>Actualizar y <br />crear Chat</span>
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="isContactInCurrentRoom">
      <button
        mat-raised-button
        type="button"
        class="submit-button"
        color="accent"
        class="save-button btn-close-exist-contact"
        (click)="matDialogRef.close()">
        <span>OK</span>
      </button>
    </ng-container>
  </div>
</div>
